<template>
  <div v-if="!isMobile()">
    <div class="page-header clear-filter" filter-color="black4">
      <div id="snackbar">COMING SOON</div>
      <div class="page-header-image2 bg">
        <video
          id="pc-bganimation"
          autoplay=""
          loop=""
          preload="auto"
          muted="muted"
        >
          <source src="/video/bg_loka.mp4?v=20211025" type="video/mp4" />
        </video>
      </div>
      <div
        id="top"
        style="
          position: absolute;
          left: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
        "
      >
        <div
          class="d-flex flex-column justify-content-lg-around"
          style="margin-top: 0px"
        >
          <div style="margin: auto; margin-top: 42%; width: 36%">
            <div style="margin: auto; margin-top: 2%; width: 100%">
              <img
                v-lazy="'/img/btn_litepaper.png'"
                style="float: left; cursor: pointer; width: 46%"
                @click="goLitePaper()"
              />
              <img
                v-lazy="'/img/btn_audit.png'"
                style="float: right; margin: auto; cursor: pointer; width: 46%"
                @click="goAudit()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <arenalink-section></arenalink-section>
    <arenametric-section></arenametric-section>
    <arenainvestor-section></arenainvestor-section>
  </div>
  <div v-else>
    <div id="snackbar">COMING SOON</div>
    <div
      class="page-header clear-filter"
      filter-color="black4"
      style="min-height: 161vw !important; height: 100% !important;"
    >    
      <div class="page-header-image3 bg">
        <video
          id="pc-bganimation"
          autoplay=""
          loop=""
          preload="auto"
          muted="muted"
        >
          <source src="/video/bg_loka_mobile.mp4?v=20211026" type="video/mp4" />
        </video>
      </div>
      <div
        id="top"
        style="
          position: absolute;
          left: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
          z-index: 0;
        "
      >
        <div
          class="d-flex flex-column justify-content-lg-around"
          style="margin-top: 100%"
        >
          <div style="width: 60%; margin: auto">
            <div
              style="
                margin: auto;
                width: 100%;
                cursor: pointer;
                z-index: 10000;
              "
            >
              <img
                v-lazy="'/img/btn_litepaper.png'"
                style="cursor: pointer; width: 100%; z-index: 0;"
                @click="goLitePaper()"
              />
              <img
                v-lazy="'/img/btn_audit.png'"
                style="margin-top: 8%; cursor: pointer; width: 100%; z-index: 0;"
                @click="goAudit()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <arenalink-section></arenalink-section>
    <arenametric-section></arenametric-section>
    <arenainvestor-section></arenainvestor-section>
  </div>
</template>
<script>
import { Parallax } from "@/components";
import ArenalinkSection from "./components/ArenaLinkSection.vue";
import ArenametricSection from "./components/ArenaMetricSection.vue";
import ArenainvestorSection from "./components/ArenaInvestorSection.vue";

export default {
  name: "arena",
  bodyClass: "arena-page",
  components: {
    Parallax,
    ArenalinkSection,
    ArenametricSection,
    ArenainvestorSection,
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    goLitePaper() {
        let url =
        "https://whitepaper.playersarena.foundation/";
      window.open(url, "_blank");      
    },
    goAudit() {
  let url =
        "https://s3.ap-northeast-2.amazonaws.com/www.leagueofkingdoms.com/doc/%5BHAECHI+AUDIT%5D+LOKA+Smart+Contract+Audit+Report+v2.0.pdf";
      window.open(url, "_blank");            
    },
    showSnackbar() {
      var x = document.getElementById("snackbar");

      // Add the "show" class to DIV
      x.className = "show";

      // After 3 seconds, remove the show class from DIV
      setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
    }
  },
};
</script>
<style>
#snackbar {
  visibility: hidden; /* Hidden by default. Visible on click */
  min-width: 50vw; /* Set a default minimum width */
  margin-left: -25vw; /* Divide value of min-width by 2 */
  background-color: #333; /* Black background color */
  color: #fff; /* White text color */
  text-align: center; /* Centered text */
  border-radius: 2px; /* Rounded borders */
  padding: 16px; /* Padding */
  position: fixed; /* Sit on top of the screen */
  z-index: 1; /* Add a z-index if needed */
  left: 50%; /* Center the snackbar */
  top: 150px; /* 30px from the bottom */
}

/* Show the snackbar when clicking on a button (class added with JavaScript) */
#snackbar.show {
  visibility: visible; /* Show the snackbar */
  /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
  However, delay the fade out process for 2.5 seconds */
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 150px; opacity: 1;}
}

@keyframes fadein {
  from {top: 0; opacity: 0;}
  to {top: 150px; opacity: 1;}
}

@-webkit-keyframes fadeout {
  from {top: 150px; opacity: 1;}
  to {top: 0; opacity: 0;}
}

@keyframes fadeout {
  from {top: 150px; opacity: 1;}
  to {top: 0; opacity: 0;}
}
</style>
